(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["predictive-search-form"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-predictive-results]');
        this.status = this.querySelector('[data-predictive-status]');
        this.cache = new Map();
        this.activeIndex = -1;
        this.onInput = this.handleInput.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onFocus = this.handleFocus.bind(this);
        this.onFocusOut = this.handleFocusOut.bind(this);
        this.onPointerMove = this.handlePointerMove.bind(this);
        this.onDocumentPointerDown = this.handleDocumentPointerDown.bind(this);
        this.input.addEventListener('input',this.onInput);
        this.input.addEventListener('keydown',this.onKeydown);
        this.input.addEventListener('focus',this.onFocus);
        this.addEventListener('focusout',this.onFocusOut);
        this.results.addEventListener('pointermove',this.onPointerMove);
        document.addEventListener('pointerdown',this.onDocumentPointerDown);
      }

      disconnectedCallback() {
        clearTimeout(this.debounceTimer);
        this.requestController?.abort();
        this.input?.removeEventListener('input',this.onInput);
        this.input?.removeEventListener('keydown',this.onKeydown);
        this.input?.removeEventListener('focus',this.onFocus);
        this.removeEventListener('focusout',this.onFocusOut);
        this.results?.removeEventListener('pointermove',this.onPointerMove);
        document.removeEventListener('pointerdown',this.onDocumentPointerDown);
        this.initialized = false;
      }

      handleInput() {
        clearTimeout(this.debounceTimer);
        this.requestController?.abort();
        const query = this.input.value.trim();
        if (query.length < 2) {
          this.clear();
          return;
        }
        this.setLoading();
        this.debounceTimer = setTimeout(() => this.fetchResults(query),200);
      }

      handleFocus() {
        const query = this.input.value.trim();
        if (query.length < 2) return;
        if (this.results.hasChildNodes()) this.open();
        else this.fetchResults(query);
      }

      handleFocusOut(event) {
        if (!this.contains(event.relatedTarget)) this.close();
      }

      handleDocumentPointerDown(event) {
        if (!this.contains(event.target)) this.close();
      }

      handlePointerMove(event) {
        const option = event.target.closest('[role="option"]');
        if (!option) return;
        const index = this.options().indexOf(option);
        if (index >= 0) this.setActive(index);
      }

      handleKeydown(event) {
        const options = this.options();
        if (event.key === 'Escape') {
          if (!this.results.hidden) {
            event.preventDefault();
            event.stopPropagation();
            this.close();
          }
          return;
        }
        if (options.length === 0) return;
        if (event.key === 'ArrowDown') {
          event.preventDefault();
          this.open();
          this.setActive((this.activeIndex + 1) % options.length);
        } else if (event.key === 'ArrowUp') {
          event.preventDefault();
          this.open();
          this.setActive((this.activeIndex - 1 + options.length) % options.length);
        } else if (event.key === 'Enter' && this.activeIndex >= 0) {
          event.preventDefault();
          options[this.activeIndex].querySelector('a')?.click();
        }
      }

      options() {
        return [...this.results.querySelectorAll('[role="option"]')];
      }

      setActive(index) {
        const options = this.options();
        this.activeIndex = index;
        options.forEach((option,optionIndex) => option.setAttribute('aria-selected',String(optionIndex === index)));
        const active = options[index];
        if (!active) {
          this.input.removeAttribute('aria-activedescendant');
          return;
        }
        active.id ||= `${this.results.id}-Option-${index + 1}`;
        this.input.setAttribute('aria-activedescendant',active.id);
        active.scrollIntoView({ block:'nearest' });
      }

      setLoading() {
        this.setAttribute('aria-busy','true');
        this.results.replaceChildren(this.message(this.dataset.loadingText));
        this.status.textContent = this.dataset.loadingText;
        this.open();
      }

      async fetchResults(query) {
        if (this.cache.has(query)) {
          this.render(this.cache.get(query),query);
          return;
        }
        this.requestController?.abort();
        this.requestController = new AbortController();
        const url = new URL(this.dataset.predictiveSearchUrl,window.location.origin);
        url.searchParams.set('q',query);
        url.searchParams.set('resources[type]','product');
        url.searchParams.set('resources[limit]','6');
        url.searchParams.set('resources[options][fields]','title,product_type,variants.title,vendor,body,tag');
        url.searchParams.set('section_id','predictive-search');
        try {
          const response = await fetch(url,{ signal:this.requestController.signal,headers:{ Accept:'text/html' } });
          const text = await response.text();
          if (!response.ok) throw new Error(`${response.status}: ${text}`);
          const section = new DOMParser().parseFromString(text,'text/html').querySelector('#shopify-section-predictive-search');
          if (!section) throw new Error('Predictive search section missing');
          const markup = section.innerHTML.trim();
          if (this.cache.size >= 20) this.cache.delete(this.cache.keys().next().value);
          this.cache.set(query,markup);
          this.render(markup,query);
        } catch (error) {
          if (error.name === 'AbortError') return;
          this.removeAttribute('aria-busy');
          this.results.replaceChildren(this.message(this.dataset.errorText));
          this.status.textContent = this.dataset.errorText;
          this.open();
        }
      }

      render(markup,query) {
        if (this.input.value.trim() !== query) return;
        this.results.innerHTML = markup;
        this.removeAttribute('aria-busy');
        this.activeIndex = -1;
        this.input.removeAttribute('aria-activedescendant');
        this.status.textContent = this.results.querySelector('[data-predictive-summary]')?.textContent.trim() || '';
        this.open();
      }

      message(text) {
        const message = document.createElement('p');
        message.className = 'predictive-search__message type-body-small';
        message.textContent = text;
        return message;
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded','true');
      }

      close() {
        this.results.hidden = true;
        this.input.setAttribute('aria-expanded','false');
        this.setActive(-1);
      }

      clear() {
        this.results.replaceChildren();
        this.status.textContent = '';
        this.removeAttribute('aria-busy');
        this.close();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
